import { createFileRoute } from "@tanstack/react-router";
import { DEFAULT_COMPANY, isCompanyId } from "../prototype/fixtures";
import { BillsScreen } from "../screens/BillsScreen";
import { billsSearch } from "../screens/purchaseSearch";

export const Route = createFileRoute("/prototype/c/$companyId/purchases/bills/")({
  validateSearch: (search) => billsSearch.parse(search),
  component: SupplierBills,
});

function SupplierBills() {
  const { companyId } = Route.useParams();
  const { filter, supplier } = Route.useSearch();
  return (
    <BillsScreen
      companyId={isCompanyId(companyId) ? companyId : DEFAULT_COMPANY}
      filter={filter}
      supplier={supplier}
    />
  );
}
